;

var forms = {
    config: {
        token: '',
        formContainer: '.loadForm',
        contentContainer: '.ajaxContent',
        loader: '/images/loading.gif',
        buttonDisabledClass: 'btn--disabled',
        pageTopOffset: 100,
        ajaxResponseType: 'json',
    },
    containerId: '',

    initAjaxForms: function () {
        var self = this
        self.loadContent()
    },

    loadAjaxForm: function (formContainer) {
        var self = this
        var containerId = self.generateUID(8)
        var url = formContainer.attr('data-url')

        formContainer.attr('id', containerId)

        $.get(url, function (data) {
            self.checkResponseResult(data)
            $(formContainer).html(data.html)
            self.initAjaxForm(self.getForm(containerId))
        }, self.config.ajaxResponseType)
    },

    loadContent: function () {
        var self = this
        $(self.config.formContainer).each(function () {
            var containerId = self.generateUID(8)
            var formContainer = $(this),
                url = $(this).attr('data-url')

            formContainer.attr('id', containerId)

            $.get(url, function (data) {
                self.checkResponseResult(data)
                $(formContainer).html(data.html)
                self.initAjaxForm(self.getForm(containerId))
            }, self.config.ajaxResponseType)
        })
    },

    getForm: function (containerId) {
        return $('#' + containerId + ' form')
    },

    initLinks: function (form) {
        var self = this
        var links = $(form).find('a.ajax')

        links.unbind('click').click(function (ev) {
            ev.preventDefault()
            var url = $(this).data('link') || $(this).attr('href')

            $.get(url, function (data) {
                self.checkResponseResult(data);
                $(form).find(self.contentContainer).replaceWith($(data.html).find(self.contentContainer))
                self.initAjaxForm(form)
                self.initLinks(form)
            }, 'json');
        });
    },

    initAjaxForm: function (form) {
        var self = this
        self.initLinks(form)

        $(form).unbind('submit').submit(function (ev) {
            ev.preventDefault()

            var button = $(form).find('input[type=submit], button[type=submit]')

            self.disableLoadingBtn(button)
            var containerId = $(form).closest('.loadForm').attr('id')
            self.postData($(form).attr('action'), form, new FormData(self.getForm(containerId)[0]), button)
        })
    },

    postData: function (url, form, formData, button) {
        var self = this
        $.ajax({
            url: url,
            method: 'POST',
            dataType: self.config.ajaxResponseType,
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                self.processResult(form, data, button);
            },
            error: function (er) { }
        })
    },

    processResult: function (form, data, button) {
        var self = this

        self.checkResponseResult(data)
        if (data.type === 'thankyou') {
            $(form).html($(data.html).find(self.config.contentContainer))
        } else {
            $(form).find(self.config.contentContainer).replaceWith($(data.html).find(self.config.contentContainer))
        }
        self.enableLoadingBtn(button)

        self.removeErrorsOnChange(form)
    },

    disableLoadingBtn: function (buttons) {
        var self = this
        buttons.attr('disabled', 'disabled')
        buttons.addClass(self.config.buttonDisabledClass)
    },

    enableLoadingBtn: function (buttons) {
        var self = this
        buttons.removeAttr('disabled')
        buttons.removeClass(self.config.buttonDisabledClass)
    },

    generateUID: function (length) {
        var text = '',
            chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

        for (var i = 0; i < length; i++) {
            text += chars.charAt(Math.floor(Math.random() * chars.length))
        }

        return text
    },

    checkResponseResult: function (data) {
        if (data.result === 'ERR') {
            alert('Something went wrong! Try to reload page.')
            window.location.reload()
        }
    },

    removeErrorsOnChange: function (form) {
        $(form).find('input, select, textarea').on('blur focus change', function (event) {
            if (event.type === 'focus') {
                $(this).data('prev-val', $(this).val())
            }
            if (event.type === 'blur' || event.type === 'change') {
                if ($(this).data('prev-val') !== $(this).val()) {
                    $(this).closest('.form__col, .form__row').removeClass('error').find('.label__error').remove()
                    $(this).removeAttr('data-prev-val')
                }
            }
        })
    }
}


forms.initAjaxForms()

forms.removeErrorsOnChange($('form'))
